module.exports = __webpack_public_path__ + "img/doc.de7674a.svg";